import AxiosConfig from '../utils/AxiosConfig';

class PaymentService {
  // Obtener pagos de un pedido específico
  async getOrderPayments(orderId) {
    try {
      const response = await AxiosConfig.get(`/b2b/orders/${orderId}/payments`);
      return response.data;
    } catch (error) {
      console.error('Error fetching order payments:', error);
      throw error;
    }
  }

  // Crear un nuevo pago para un pedido
  async createPayment(orderId, paymentData) {
    try {
      const response = await AxiosConfig.post(`/b2b/orders/${orderId}/payments`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error creating payment:', error);
      throw error;
    }
  }

  // Actualizar estado de pago de un pedido
  async updatePaymentStatus(orderId, paymentStatusData) {
    try {
      const response = await AxiosConfig.put(`/b2b/orders/${orderId}/payment-status`, paymentStatusData);
      return response.data;
    } catch (error) {
      console.error('Error updating payment status:', error);
      throw error;
    }
  }

  // Obtener métodos de pago disponibles
  getPaymentMethods() {
    return [
      { value: 'CASH', label: 'Efectivo' },
      { value: 'TRANSFER', label: 'Transferencia' },
      { value: 'CHECK', label: 'Cheque' },
      { value: 'CARD', label: 'Tarjeta' }
    ];
  }

  // Obtener estados de pago disponibles
  getPaymentStatuses() {
    return [
      { value: 'UNPAID', label: 'Sin pagar' },
      { value: 'PARTIAL', label: 'Pago parcial' },
      { value: 'PAID', label: 'Pagado' },
      { value: 'OVERDUE', label: 'Vencido' }
    ];
  }

  // Validar datos de pago
  validatePaymentData(paymentData) {
    const errors = {};

    if (!paymentData.amount || paymentData.amount <= 0) {
      errors.amount = 'El monto debe ser mayor a 0';
    }

    if (!paymentData.date) {
      errors.date = 'La fecha es requerida';
    }

    if (!paymentData.method) {
      errors.method = 'El método de pago es requerido';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }

  // Validar datos de estado de pago
  validatePaymentStatusData(paymentStatusData) {
    const errors = {};

    if (!paymentStatusData.paymentStatus) {
      errors.paymentStatus = 'El estado de pago es requerido';
    }

    if (paymentStatusData.paymentStatus === 'PARTIAL' && (!paymentStatusData.paymentAmount || paymentStatusData.paymentAmount <= 0)) {
      errors.paymentAmount = 'El monto es requerido para pago parcial';
    }

    if (paymentStatusData.paymentStatus === 'PAID' && (!paymentStatusData.paymentAmount || paymentStatusData.paymentAmount <= 0)) {
      errors.paymentAmount = 'El monto es requerido para pago completo';
    }

    if (!paymentStatusData.paymentDate) {
      errors.paymentDate = 'La fecha de pago es requerida';
    }

    if (!paymentStatusData.paymentMethod) {
      errors.paymentMethod = 'El método de pago es requerido';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
}

export default new PaymentService();
